export default __webpack_public_path__ + "592dab3957f45531944f7c697bf38ef6.png";